import ForwardDate, {PICKUP_DATE_VALID_SHIPPER_TYPES} from './ForwardDate.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

/**
 * Pickup date for label config
 *
 * @param {Object} props
 * @param {String} props.label
 * @param {Boolean} [props.nextBusinessDay]
 * @returns {React.ReactNode}
 */
export default function PickupDate({
  label = 'Pickup Date',
  nextBusinessDay = false,
}) {
  const propertySpecs = PickupDate.propertySpecList[0]

  return (
    <ForwardDate
      label={label}
      nextBusinessDay={nextBusinessDay}
      propertySpecs={propertySpecs}
    />
  )
}

PickupDate.propertySpecList = [
  {
    validShipperTypes: PICKUP_DATE_VALID_SHIPPER_TYPES,
    labelPropertiesFunc: () => ['pickup_date'],
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
